import '../PublicPage.css';

export default function PortugalItineraryPage() {
    return (
        <div className="public-page portugal-page">
            <header className="public-hero">
                <div className="public-hero-content">
                    <h1>Portugal Itinerary</h1>
                    <p>Fado, azulejos, and the stunning Atlantic coast.</p>
                </div>
            </header>

            <section className="public-section white-bg">
                <div className="section-inner">
                    <div className="story-grid">
                        <div className="modern-card">
                            <h3>Why visit Portugal?</h3>
                            <p>Portugal offers a unique blend of ancient history, world-class surfing, and incredible food. From the hills of Lisbon to the vineyards of the Douro Valley, it's a traveler's dream.</p>
                        </div>
                        <div className="modern-card">
                            <h3>Featured: 10-Day Portugal Immersion</h3>
                            <p>Lisbon, Sintra, Porto, and the Algarve. The perfect introduction to Portuguese culture and landscapes.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="public-section slate-bg">
                <div className="section-inner">
                    <h2>Top Destinations</h2>
                    <ul className="benefits-list">
                        <li><strong>Lisbon</strong>: Historic charm and vibrant nightlife.</li>
                        <li><strong>Porto</strong>: Riverside beauty and famous wine cellars.</li>
                        <li><strong>Algarve</strong>: Dramatic cliffs and golden beaches.</li>
                        <li><strong>Sintra</strong>: Fairytale palaces and mystical forests.</li>
                    </ul>
                </div>
            </section>

            <section className="public-section white-bg" style={{ textAlign: 'center' }}>
                <div className="section-inner">
                    <h2>Ready to plan your Portugal trip?</h2>
                    <p style={{ marginBottom: '32px' }}>Let Raisa AI create a personalized itinerary for you in seconds.</p>
                    <button className="submit-btn-primary" style={{ maxWidth: '300px' }} onClick={() => window.location.href = '/?prompt=Plan a 10-day trip to Portugal exploring Lisbon, Porto and the Algarve'}>
                        Plan my Portugal Trip
                    </button>
                </div>
            </section>
        </div>
    );
}
